import http from '../../api/http';
/**
 * 获取校园聚合付账户基本信息
 */
export const  getAccInfo=(params)=>  http("get", '/user/campusPay/accountInfo', params)
/**
 * 解绑
 */
export const  setUnbind=(params)=>  http("post", '/user/campusPay/unbind?userId='+params.userId+'&projectId='+params.projectId+'&loginCode='+params.loginCode+'&accountId='+params.accountId+'&phoneSystem='+params.phoneSystem)
/**
 * 充值
 */
export const rechargeBalance=(params)=>http('post','/settlement/campus/recharge/balance?userId='+params.userId+'&projectId='+params.projectId+'&loginCode='+params.loginCode+'&accountId='+params.accountId
+'&telPhone='+params.telPhone+'&payWay='+params.payWay+'&signature='+params.signature+'&rechargeMoney='+params.rechargeMoney+'&phoneSystem='+params.phoneSystem
)